module.exports = __webpack_public_path__ + "static/poster_tb_jp-2c77e19936cc1d9719aea2a98b4b1bae.png";